import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function OrganicBatteryMaterialsUseCase() {
  return (
    <>
    <section
      id="organic-batteries"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Organic Battery Materials
          </h1>
          <p className="text-slate-300 space-y-2">
            Organic batteries use carbon-based molecules instead of metal-based materials for energy storage, offering a more sustainable and potentially safer alternative to traditional lithium-ion systems.
            They enable tunable redox potentials, lightweight designs, and easier recyclability — key features for the future of grid storage, wearables, and flexible electronics.

            <br /><br />

            Key molecular properties include stable redox activity, fast charge/discharge kinetics, high theoretical capacity, low solubility in electrolytes, and long-term chemical and electrochemical stability.
            Materials must also maintain structural integrity through repeated cycles while minimising side reactions and degradation pathways.

            <br /><br />

            Organic battery research spans small-molecule systems (e.g. quinones, imides) and polymer-based electrodes, often tailored for specific use cases like flow batteries, sodium-ion systems, or ultra-thin wearables.
          </p>
        </div>

        {/* How Apoello Helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Access redox potentials, ionisation potential, electron affinity, and reorganisation energy.
    </li>
    <li>
      Predict charge mobility and assess structural stability for organic redox-active materials.
    </li>
    <li>
      Explore solubility and redox tuning potential for use in flow or solid-state battery architectures.
    </li>
    <li>
      Order molecules or related building blocks.
    </li>
  </ul>
</div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            The shift to organic batteries can reduce reliance on scarce metals and enable safer, greener storage technologies.
            DiaDEM™ helps accelerate discovery by enabling rapid, large-scale virtual screening of organic redox materials — cutting down development time and supporting the transition to sustainable energy systems.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
